(() => {
  const initialiseSection = (section) => {
    if (!section || section.dataset.coastdMemoryReady === 'true') return;

    const track = section.querySelector('[data-coastd-track]');
    if (!track) return;

    section.dataset.coastdMemoryReady = 'true';

    const scroll = (direction) => {
      const card = track.querySelector('.coastd-memory__item');
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      const amount = card ? card.getBoundingClientRect().width + gap : 380;

      if (typeof track.scrollBy === 'function') {
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      } else {
        track.scrollLeft += amount * direction;
      }
    };

    section.querySelector('[data-coastd-previous]')?.addEventListener('click', () => scroll(-1));
    section.querySelector('[data-coastd-next]')?.addEventListener('click', () => scroll(1));

    section.querySelectorAll('.coastd-memory__flip').forEach((label) => {
      label.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();

        const input = document.getElementById(label.getAttribute('for'));
        if (input) input.checked = !input.checked;
      });
    });
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-coastd-memory]').forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAll(event.target);
  });
})();
